import React from 'react'
import { ReactElement } from 'react'

import Card from '../../../../../1stlog-ui/src/components/Card'
import {
  FieldPrefix,
  useField,
} from '../../../../../1stlog-ui/src/components/Field'
import CustomPriceForm from './CustomPriceForm'

const CustomPrice = (): ReactElement => {
  const pickupProvider = useField('pickup.provider', { ignorePrefix: true })
  const deliveryProvider = useField('delivery.provider', { ignorePrefix: true })
  const pickupIsManualDisposition = useField('pickup.isManualDisposition', {
    ignorePrefix: true,
  })
  const deliveryIsManualDisposition = useField('delivery.isManualDisposition', {
    ignorePrefix: true,
  })

  // only when provider is internal and not only manual disposition
  if (
    (pickupProvider === 'basic' && !pickupIsManualDisposition) ||
    (deliveryProvider === 'basic' && !deliveryIsManualDisposition)
  ) {
    return (
      <Card title={i18n.t('custom_price', 'Sonderpreis')}>
        <FieldPrefix prefix="customPrice">
          <CustomPriceForm />
        </FieldPrefix>
      </Card>
    )
  }

  return <></>
}

export default CustomPrice
